/**
 * 学习服务钩子
 * 提供便捷访问学习服务的方法
 *
 * 核心功能：
 * 1. 获取学习上下文
 * 2. 提供类型安全的学习服务访问
 * 3. 确保在Provider内部使用
 */
import { useContext } from 'react';
import { LearningContext } from '../contexts/LearningContext.js';
/**
 * 使用学习服务钩子
 * 便于在组件中使用学习服务
 *
 * @returns 学习服务实例
 * @throws 如果在LearningProvider外部使用则抛出错误
 *
 * @example
 * ```tsx
 * const learningService = useLearning();
 *
 * // 保存学习笔记
 * const saveNote = async () => {
 *   const note = {
 *     originalText: '...',
 *     translatedText: '...',
 *     sourceLanguage: 'en',
 *     targetLanguage: 'zh',
 *   };
 *   const result = await learningService.saveNote(note);
 * };
 * ```
 */
export function useLearning() {
    const learningService = useContext(LearningContext);
    if (learningService === null) {
        throw new Error('useLearning must be used within a LearningProvider');
    }
    return learningService;
}
/**
 * 默认导出钩子函数
 * 便于导入使用
 */
export default useLearning;
//# sourceMappingURL=useLearning.js.map